import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNil, map } from 'lodash';
import { KeyValue } from '@angular/common';
import { ISharedAreaState } from 'app/modules/shared-area/shared-area.module';
import { IPanelState } from './panel.state';
import { IView } from '../models/IView';

// Access through shared area state
export const getSharedAreaState = createFeatureSelector<ISharedAreaState>('shared');

export const getPanelState = createSelector(
  getSharedAreaState,
  (shared: ISharedAreaState) => shared.panels
);

export const getDossierView = createSelector(
  getPanelState,
  (state: IPanelState) => state.dossierView
);

export const isDossierPanelExpanded = (selector: string) => createSelector(
  getDossierView,
  (view: IView) => {
    const panel = view.panels[selector];
    return isNil(panel) ? !!view.openAllPanels : <boolean>panel;
  }
);

export const getDefaultViewName = createSelector(
  getPanelState,
  (state: IPanelState) => {
    const namedViews = state.namedViews;
    let id = null;
    for (const view in namedViews) {
      if (namedViews.hasOwnProperty(view) && namedViews[view].view.isDefaultView) {
        id = view;
      }
    }
    return id;
  }
);

export const getNamedViews = createSelector(
  getPanelState,
  (state: IPanelState) => state.namedViews
);

function compareViewsAlphabetically(a: IView, b: IView) {
  if (a.viewName < b.viewName) {
    return -1;
  }
  if (a.viewName > b.viewName) {
    return 1;
  }
  return 0;
}

function compareViews(a: KeyValue<string, { view: IView }>, b: KeyValue<string, { view: IView }>): number {
  if (a.value.view.isSystem) {
    if (b.value.view.isSystem) {
      return compareViewsAlphabetically(a.value.view, b.value.view);
    } else {
      return -1;
    }
  } else {
    if (b.value.view.isSystem) {
      return 1;
    } else {
      return compareViewsAlphabetically(a.value.view, b.value.view);
    }
  }
}

export const getNamedViewsKeyValue = createSelector(
  getNamedViews,
  namedViews => {
    const keyValueViews = map(namedViews, (view: { view: IView }) => ({ key: view.view.viewName, value: view }));
    keyValueViews.sort(compareViews);
    return keyValueViews;
  }
);
